var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.6665 10.8333C1.6665 10.4167 2.08317 10 2.49984 10C2.9165 10 3.33317 10.4167 3.33317 10.8333C3.33317 11.25 3.33317 15 3.33317 15C3.33317 15.9205 4.07936 16.6667 4.99984 16.6667H14.9998C15.9203 16.6667 16.6665 15.9205 16.6665 15V10.8333C16.6665 10.3731 17.0396 10 17.4998 10C17.9601 10 18.3332 10.3731 18.3332 10.8333V15C18.3332 16.8409 16.8408 18.3333 14.9998 18.3333H4.99984C3.15889 18.3333 1.6665 16.8409 1.6665 15C1.6665 15 1.6665 11.25 1.6665 10.8333Z",
    fill: "#A5A5AB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 10.8335,
    y: 12.5,
    width: 1.66667,
    height: 11.6667,
    rx: 0.833333,
    transform: "rotate(-180 10.8335 12.5)",
    fill: "#A5A5AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5774 7.74473C13.9028 7.41929 14.4305 7.41929 14.7559 7.74473C15.0814 8.07016 15.0814 8.5978 14.7559 8.92324L10.5893 13.0899C10.2759 13.4033 9.77197 13.4166 9.44253 13.1201L5.27586 9.37006C4.93377 9.06218 4.90604 8.53527 5.21392 8.19318C5.5218 7.85109 6.04871 7.82336 6.3908 8.13124L9.9698 11.3523L13.5774 7.74473Z",
    fill: "#A5A5AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7094c41a161912517ca04206faa097b9.svg";
export { ForwardRef as ReactComponent };